import axios from "axios";
import { API_BASE_URL } from "./config";

const api = axios.create({
    baseURL: `${API_BASE_URL}/api/users`,
    withCredentials: true,
});

export const getUserById = async (uId) => {
    return await api.get(`/find/${uId}`);
};

// --- Group 2: Channel & Profile -------------------------------------------

// Public channel view: user profile (minus password/email) + their videos
// + counts, in one call.
export const getChannelProfile = async (userId) => {
    const response = await api.get(`/channel/${userId}`);
    return response.data; // { user, videos, videoCount, subscriberCount }
};

// Account settings: update name/bio/profileImageUrl/bannerUrl/handle.
// Only these whitelisted fields are accepted by the backend regardless of
// what else is included here.
export const updateProfile = async (userId, updates) => {
    const response = await api.put(`/${userId}`, updates);
    return response.data;
};

// Change password while logged in (separate from the forgot-password/email
// reset flow).
export const changePassword = async (currentPassword, newPassword) => {
    const response = await api.put("/change-password", { currentPassword, newPassword });
    return response.data;
};

// Live-validates a handle as the user types it into Settings.
export const checkHandleAvailability = async (handle) => {
    const response = await api.get(`/handle-available/${encodeURIComponent(handle)}`);
    return response.data; // { available, reason? }
};

export const subscribe = async (uId) => {
    return await api.put(`/sub/${uId}`);
};

export const unsubscribe = async (uId) => {
    return await api.put(`/unsub/${uId}`);
};

export const sendEmail = async (emaildetails) => {
    return await api.post("/sendemail", emaildetails);
};
